<ion-header>
  <ion-toolbar color="warning">
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>Debug Menu</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- <ion-item>
    <ion-select
      (ionChange)="onLogStrategyChange($event.detail.value)"
      [(ngModel)]="selectedLogStoringStrategy"
      label="Log storing"
      label-placement="fixed"
    >
      <ion-select-option value="none">None</ion-select-option>
      <ion-select-option value="buffer">Buffer</ion-select-option>
      <ion-select-option value="all">All</ion-select-option>
    </ion-select>
  </ion-item> -->

  <ion-item>
    <ion-label>Send logs to server</ion-label>

    <ion-button (click)="sendLogsToServer()">Send</ion-button>
  </ion-item>

  <ion-item>
    <ion-label>Copy logs to clipboard</ion-label>

    <ion-button (click)="copyLogsToClipboard()">Copy</ion-button>
  </ion-item>

  <ion-item>
    <ion-label>Reset all logs</ion-label>

    <ion-button (click)="resetLogs()">Reset</ion-button>
  </ion-item>

  <ion-item>
    <ion-label>Copy enviroment variables to clipboard</ion-label>

    <ion-button (click)="copyEnvVariables()">Copy</ion-button>
  </ion-item>



</ion-content>
